import React from 'react';
import { genericMemo } from '@direct-frontend/stdlib';

import { HStack } from '../Stack';
import { cn } from '../../lib/css/className/className';
import { TestProps } from '../../internal/types/testTypes';
import { ClassNameProps } from '../../internal/types/classNameTypes';

import { Dot } from './Dot';
import './Dots.css';

const cls = cn('Dots');

export interface DotsProps extends TestProps, ClassNameProps {
    /** Массив точек */
    items: Dot[];
    /** id выбранного элемента */
    selectedIndex?: number;
    /** Обработчик клика по точке */
    onClick: (item: Dot, index: number) => void;
}

export const Dots = genericMemo(function Dots({
    items,
    selectedIndex,
    onClick,
    className,
    'data-testid': dataTestId = 'Dots',
}: DotsProps) {
    return (
        <HStack className={cls('', [className])} justifyContent="center" data-testid={dataTestId} gap="8">
            {items.map((item, index) => (
                <Dot
                    dot={item}
                    index={index}
                    isActive={index === selectedIndex}
                    onClick={onClick}
                    key={item.id}
                    data-testid={`${dataTestId}.Dot-${index}`}
                />
            ))}
        </HStack>
    );
});
